import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const ScoreTitleStyled = styled.div<T>`
  font-size: 1.5em;
  text-align: center;
  padding-bottom: 1em;
`;
